import { Box, Typography } from '@mui/material';

import { headline, subhead } from '../copy';

export interface HeadlineProps {
  counts: { needs_customer: number; ready: number };
  enrollingCount: number;
  liveCount: number;
  unknownCount?: number;
}

/** AC-5: the clinic page's headline + subhead, derived from fold counts. */
export function Headline({ counts, enrollingCount, liveCount, unknownCount = 0 }: HeadlineProps) {
  return (
    <Box>
      <Typography component="h2" sx={{ fontSize: '24px', fontWeight: 700, color: 'text.primary' }}>
        {headline(counts, unknownCount)}
      </Typography>
      <Typography sx={{ fontSize: '13.5px', color: 'text.secondary', mt: 0.5 }}>
        {subhead(enrollingCount, liveCount, unknownCount)}
      </Typography>
    </Box>
  );
}
